import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import useAppCustom from '@hooks/useAppCustom';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import CouponHistoryFragment from './fragments/CouponHistoryFragment';
import DownloadCouponFragment from './fragments/DownloadCouponFragment';
import ExternalCouponFragment from './fragments/ExternalCouponFragment';
import MyCouponFragment from './fragments/MyCouponFragment';
import PaperCouponFragment from './fragments/PaperCouponFragment';

interface Params {
    type: 'MY' | 'DOWNLOAD' | 'HISTORY' | 'EXTERNAL' | 'PAPER';
}

const CouponActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { type } = params;
    const { t } = useTranslation('coupon');
    const { stepReplace } = useStepFlow('CouponActivity');
    const { useExternalCouponInCoupon } = useAppCustom().coupon;
    return (
        <AppScreen>
            <Header title={t('title')} noShadow/>
            <TabList variant='solid'>
                <TabItem selected={type === 'MY'}
                    onClick={() => stepReplace({ type: 'MY' })}>
                    {t('tabs.my')}
                </TabItem>
                <TabItem selected={type === 'DOWNLOAD'}
                    onClick={() => stepReplace({ type: 'DOWNLOAD' })}>
                    {t('tabs.download')}
                </TabItem>
                {useExternalCouponInCoupon && (
                    <TabItem selected={type === 'EXTERNAL'}
                        onClick={() => stepReplace({ type: 'EXTERNAL' })}>
                        {t('tabs.external')}
                    </TabItem>
                )}
                <TabItem selected={type === 'PAPER'}
                    onClick={() => stepReplace({ type: 'PAPER' })} >
                    {t('tabs.paper')}
                </TabItem>
                <TabItem selected={type === 'HISTORY'}
                    onClick={() => stepReplace({ type: 'HISTORY' })}>
                    {t('tabs.history')}
                </TabItem>
            </TabList>
            {type === 'MY' && (
                <MyCouponFragment/>
            )}
            {type === 'DOWNLOAD' && (
                <DownloadCouponFragment/>
            )}
            {type === 'HISTORY' && (
                <CouponHistoryFragment/>
            )}
            {type === 'EXTERNAL' && (
                <ExternalCouponFragment/>
            )}
            {type === 'PAPER' && (
                <PaperCouponFragment/>
            )}
        </AppScreen>
    );
};

export default CouponActivity;
